import { Middleware } from 'redux';
import { EndPoints } from 'src/config';
import { isAuthenticatedSelector, tokenSelector } from 'src/features/auth';
import { resetAuth } from 'src/features/auth/store/authSlice';
import { checkApiError } from 'src/handlers';
import { appHeaders } from 'src/helpers/auth';
import { RootState } from 'src/store';
import { START_LOAD_OCM_ACTION } from '../ocm.types';
import { resetOutOfSoldIndicators, updateOcmData, updateOcmError, updateOcmIsLoading } from '../ocmSlicer';

export const ocmMiddleware: Middleware = (api) => (next) => async (action) => {
  const { type } = action;

  if (type !== START_LOAD_OCM_ACTION) {
    next(action);
    return;
  }

  const state: RootState = api.getState();

  const isAuthenticated = isAuthenticatedSelector(state);
  const token = tokenSelector(state);

  // to valid if user is not authenticated then reset auth state
  if (!isAuthenticated || !token) {
    next(resetAuth());
    return;
  }

  next(resetOutOfSoldIndicators());
  next(updateOcmIsLoading({ isLoading: true }));
  next(updateOcmError({ error: null }));

  try {
    const result = await fetch(EndPoints.getOcm, {
      method: 'POST',
      headers: appHeaders(token),
    });

    const json = await result.json();

    checkApiError(json);

    next(updateOcmData({ data: json }));
  } catch (e) {
    next(updateOcmError({ error: e as unknown as Error }));
  } finally {
    next(updateOcmIsLoading({ isLoading: false }));
  }
};
